import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button , Grid } from 'semantic-ui-react';
import { Link } from "react-router";
import ThemeColorSetting from '../../../constants/themeColor';
import waveGraph from '../../../assets/pattern/bank-note.svg';

const styles = {
  container : {
    backgroundColor : ThemeColorSetting.white,
    backgroundImage: 'url(' +waveGraph+ ')',
		backgroundSize : '100px auto',
		backgroundRepeat : 'repeat',
    padding : '5vh 0px'
  },
  btnContainer : {
    display : 'flex',
    flexDirection : 'row',
    alignItems : 'center',
    justifyContent : 'center'
  }
}

class PriceFooter extends Component {
  render() {
    const { string , mixpanel } = this.props;
    return(
      <Grid.Row style={styles.container}>
        <Grid.Column style={styles.btnContainer}>
          <Link to={{  pathname : '/pricing' , query : { target : 'hardware' } }}>
            <Button onClick={()=>mixpanel.track("Pitch Page", { action : 'link to', url : "Pricing Page" })} color='black' size='big'>{string['understandMoreAboutPrice']}</Button>
          </Link>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string,
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(PriceFooter)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/price/priceFooter.js
 **/